import React, { Component } from "react";
import { connect } from 'react-redux';
import {
	Grid,
	Row,
	Col,
	OverlayTrigger,
	Popover,
} from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import { confirmAlert } from 'react-confirm-alert';
import { objectsConstants as OC } from 'redux/constant/objects-constant';
import { MdNavigateBefore, MdNavigateNext } from 'react-icons/md';
import Confirmalertfordelete from '../../ThemeComponents/confirmAlertForDelete';
import { SortableContainer, SortableElement, SortableHandle, arrayMove } from 'react-sortable-hoc';
import { withRouter } from 'react-router-dom';
import { brandActions } from "../../../redux/actions/brand-actions";
import ExportAttributeForm from "./ExportAttributeForm";
var cloneDeep = require('lodash.clonedeep');
let _ = require('lodash');

const DragHandle = SortableHandle(() => <OverlayTrigger placement="bottom" overlay={<Popover id="tooltip">Click and Hold to Drag</Popover>}><span className="moveIcon orderDetailsAction"></span></OverlayTrigger>);
const SortableItem = SortableElement(({ value, deleteConfirmListItem, onInputHandler, view_mode }) => (

	<tr test1={`innerItem-${value.key}`} key={`innerItem-${value.key}`} >

		<td>{value.key + 1}</td>
		<td >{value.value['title']}</td>
		<td >{value.value['attribute_type']}</td>
		<td>
			<input
				type="text"
				className="form-control"
				name='header_label'
				value={value.value['header_label'] ? value.value['header_label'] : ''}
				onChange={(e) => { onInputHandler(e, value.key) }}
				disabled={view_mode}
			/>
		</td>
		<td>
			<DragHandle />
			<OverlayTrigger placement="bottom" overlay={<Popover id="tooltip">Delete Row</Popover>}>
				<span>
					<button
						onClick={() => { deleteConfirmListItem(value.key, value.value['attr_id']) }} className="deleteIcon orderDetailsAction"
						disabled={view_mode}
					>&nbsp;</button>
				</span>
			</OverlayTrigger>
		</td>
	</tr>
));

const SortableList = SortableContainer(({ exportableAttributes, onInputHandler, deleteConfirmListItem, view_mode }) => {
	return (
		<tbody>
			{
				exportableAttributes.map((value, index) => (

					<SortableItem
						key={`item-${index}`}
						index={index}
						value={{ value: value, key: index }}
						test={`item-${index}`}
						onInputHandler={onInputHandler}
						deleteConfirmListItem={deleteConfirmListItem}
						view_mode={view_mode}
						disabled={view_mode}
					/>

				))
			}

		</tbody>
	);
});

class ExportDataAttributePage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			all_attributes: [],
			exportable_attributes: this.props.fetchedExportAttributes ? this.props.fetchedExportAttributes.export_attributes ? this.props.fetchedExportAttributes.export_attributes : [] : [],
			filtered_attributes: [],
			type: this.props.fetchedExportAttributes ? 'edit' : '',
			exportAdded: false,
			isChanged: false,
			export_attributes_added: this.props.fetchedExportAttributes ? this.props.fetchedExportAttributes.export_attributes_added : '',
			export_attributes_dropdown: [],
			export_attribute: OC.export_attribute,
		};
	}

	changeAttribute = (e, key) => {
		const { name, value } = e.target;
		const tempAttributesState = cloneDeep(this.state.exportable_attributes);
		tempAttributesState[key][name] = value;
		this.setState({ exportable_attributes: tempAttributesState })
	}
	onSortEnd = ({ oldIndex, newIndex }) => {
		this.setState(({ exportable_attributes }) => ({
			exportable_attributes: arrayMove(exportable_attributes, oldIndex, newIndex),
		}));
	};
	onInputHandler = (e, rowIndex) => {
		const atts = cloneDeep(this.state.exportable_attributes);
		const { name, value } = e.target;
		atts[rowIndex][name] = value;
		this.setState({ exportable_attributes: atts });
	}

	deleteConfirmListItem = (id) => {
		confirmAlert({
			customUI: ({ onClose }) => {
				return (
					<Confirmalertfordelete typeName="row" description={"Are you sure to delete this row"} onClosePro={onClose} deleteType={() => this.deleteAttribute(id)} />
				)
			}
		})
	}

	deleteAttribute = (key) => {
		const tempAttributesState = cloneDeep(this.state.exportable_attributes);
		tempAttributesState.splice(key, 1);
		this.setState({ exportable_attributes: tempAttributesState }, () => {
			const titles = this.state.exportable_attributes.map(element => {
				return element.title
			})
			const attributesDrop = [];
			this.state.export_attributes_dropdown.forEach((data, index) => {
				if (titles.includes(data.title)) {
					attributesDrop.push({
						...data,
						isDisabled: true
					})
				}
				else {
					attributesDrop.push({
						...data,
						isDisabled: false
					})
				}
			})
			this.setState({
				export_attributes_dropdown: attributesDrop,
			})
		})
	}

	onSubmitAttributes = () => {
		let obj;
		obj = {
			attributes_type: 'export',
			brand_attributes: [...this.state.exportable_attributes],
			_method: 'put',
		}
		this.props.storeBrandDataDefinitionCall(obj, this.props.storedBrand.id).then(res => {
			this.props.exportsHandler(res.result.data_definition);
			this.setState({
				exportAdded: true,
				isChanged: false,
			})
		})
	}

	componentDidMount() {
		if (this.props.fetchedExportAttributes) {
			if (this.props.fetchedExportAttributes.export_attributes_added == 0 || this.props.fetchedExportAttributes.export_attributes_added == 1) {
				this.setState({
					all_attributes: [...this.props.fetchedExportAttributes.product_attributes, ...this.props.fetchedExportAttributes.order_attributes]
				}, () => {
					let newArray = [];
					if (!_.isEmpty(this.props.fetchedExportAttributes.export_attributes)) {
						newArray = this.props.fetchedExportAttributes.export_attributes;
					}
					else {
						this.state.all_attributes.forEach(att => {
							if ('exportable' in att && att.exportable === true) {
								newArray.push({
									title: att.title,
									attribute_id: att.id,
									db_column: att.db_column,
									attribute_type: 'product',
									header_label: ''
								})
							}
							else if (att.exportable === undefined) {
								newArray.push({
									title: att.title,
									attribute_id: att.id,
									db_column: att.db_column,
									attribute_type: 'order',
									header_label: ''
								})
							}
						})
					}

					//
					const titles = newArray.map(element => {
						return element.title
					})
					const attributesDrop = [];
					newArray.forEach((data, index) => {
						if (titles.includes(data.title)) {
							attributesDrop.push({
								...data,
								isDisabled: true
							})
						}
						else {
							attributesDrop.push({
								...data,
								isDisabled: false
							})
						}
					})
					this.setState({
						...this.state,
						exportable_attributes: newArray,
						export_attributes_dropdown: attributesDrop,
						isChanged: true
					})
				})
			}
		}
	}
	handleSubmit = (data) => {
		this.setState({
			exportable_attributes: [
				...this.state.exportable_attributes,
				data
			]
		}, () => {
			//
			const titles = this.state.exportable_attributes.map(element => {
				return element.title
			})
			const attributesDrop = [];
			this.state.export_attributes_dropdown.forEach((data, index) => {
				if (titles.includes(data.title)) {
					attributesDrop.push({
						...data,
						isDisabled: true
					})
				}
				else {
					attributesDrop.push({
						...data,
						isDisabled: false
					})
				}
			})
			//
			this.setState({
				...this.state,
				export_attribute: {},
				export_attributes_dropdown: attributesDrop,
			})
		})
	}
	componentDidUpdate(prevProps, prevState) {
		if ((this.props.exportLength.length !== prevProps.exportLength.length) || (!_.isEqual(this.props.orderAttributes, prevProps.orderAttributes) && this.props.orderAttributes !== []) ||
			(!_.isEqual(this.props.productAttributes, prevProps.productAttributes) && this.props.productAttributes !== [])) {
			this.setState({
				all_attributes: [...this.props.productAttributes, ...this.props.orderAttributes]
			}, () => {
				let newArray = [];
				this.state.all_attributes.forEach(att => {
					if ('exportable' in att && att.exportable === true) {
						newArray.push({
							title: att.title,
							attribute_id: att.id,
							db_column: att.db_column,
							attribute_type: 'product',
							header_label: ''
						})
					}
					else if (att.exportable === undefined) {
						newArray.push({
							title: att.title,
							attribute_id: att.id,
							db_column: att.db_column,
							attribute_type: 'order',
							header_label: ''
						})
					}
				})

				//
				const titles = newArray.map(element => {
					return element.title
				})

				const attributesDrop = [];
				newArray.forEach((data, index) => {
					if (titles.includes(data.title)) {
						attributesDrop.push({
							...data,
							isDisabled: true
						})
					}
					else {
						attributesDrop.push({
							...data,
							isDisabled: false
						})
					}
				})
				let latest;
				if (this.props.fetchedExportAttributes.export_attributes !== undefined) {

					const exportTitles = this.props.fetchedExportAttributes.export_attributes.map(element => {
						return element.title
					})

					latest = newArray.map((elem, index) => {
						let find = this.props.fetchedExportAttributes.export_attributes.findIndex(function (currentValue) {
							return elem.title == currentValue.title;
						})
						if (find != -1) {
							let new_label = this.props.fetchedExportAttributes.export_attributes[find]['header_label'];
							newArray[index]["header_label"] = new_label;

						}
					})
				}
				//

				this.setState({
					...this.state,
					exportable_attributes: newArray,
					export_attributes_dropdown: attributesDrop,
					isChanged: true
				})
			})
		}

		if (!_.isEqual(this.state.exportable_attributes, prevState.exportable_attributes) && this.state.exportable_attributes.length > 0) {
			this.setState({
				isChanged: true
			})
		}

		if (this.props.complete_definition !== prevProps.complete_definition) {
			if (this.props.complete_definition.export_attributes_added == 0) {
				this.setState({
					isChanged: true
				})
			}
		}
	}

	render() {
		const { exportable_attributes } = this.state;
		const { view_mode } = this.props;
		return (<Grid fluid>
			<Row>
				<Col md={12}>
					<Card
						ctTableResponsive
						content={
							<div>
								<Grid fluid>
									<Row>
										<Col md={12}>
											<h3 style={{ textAlign: 'center', fontWeight: "500" }}>Export Data Attributes</h3>
											<div className="table-responsive">
												<table className="table theme_table  table-striped blank mt-xlg">
													<thead>
														<tr>
															<th>Order</th>
															<th>Title</th>
															<th>Type</th>
															<th>Header</th>
															<th>Control</th>
														</tr>
													</thead>
													{
														<SortableList
															axis='y'
															exportableAttributes={exportable_attributes}
															onSortEnd={this.onSortEnd} onInputHandler={this.onInputHandler}
															deleteConfirmListItem={this.deleteConfirmListItem}
															useDragHandle
															view_mode={view_mode}
														/>
													}
													{
														!view_mode &&
														<tbody>
															<ExportAttributeForm
																exportableAttributes={exportable_attributes}
																exportableAttributesDropdown={this.state.export_attributes_dropdown}
																attributesLength={exportable_attributes.length + 1}
																handleSubmit={this.handleSubmit}
																export_attribute={this.state.export_attribute}
															/>
														</tbody>
													}
												</table>
											</div>
											{
												!view_mode &&
												<div className="col-md-12 text-center mt-md">
													{
														exportable_attributes.length > 0 &&
														<button className="customBtn btnBlue" onClick={this.onSubmitAttributes} disabled={this.state.isChanged ? false : true} >Save Updates</button>
													}
												</div>
											}
										</Col>
									</Row>
								</Grid>
							</div>
						} />
					{
						!view_mode &&
						<div className="stepsNav">
							<div className="text-center">
								<button onClick={this.props.previousStep} className="stepNav prev"><MdNavigateBefore /></button>
								<span className="display_ib mt-xs">Prev</span>
							</div>

							{
								this.state.exportAdded && this.props.complete_definition.export_attributes_added == 1 &&
								<div className="text-center">
									<button onClick={this.props.nextStep} className="stepNav next" disabled={!this.state.isChanged ? false : true}><MdNavigateNext /></button>
									<span className="display_ib mt-xs">Next</span>
								</div>
							}

							{
								this.state.type === 'edit' && exportable_attributes.length > 0 && !this.state.exportAdded && this.state.export_attributes_added == 1 &&
								<div className="text-center">
									<button onClick={this.props.nextStep} className="stepNav next" disabled={!this.state.isChanged ? false : true}><MdNavigateNext /></button>
									<span className="display_ib mt-xs">Next</span>
								</div>
							}
						</div>
					}
					{
						view_mode &&
						<div className="stepsNav">
							<div className="text-center">
								<button onClick={this.props.previousStep} className="stepNav prev"><MdNavigateBefore /></button>
								<span className="display_ib mt-xs">Prev</span>
							</div>

							<div className="text-center">
								<button onClick={this.props.nextStep} className="stepNav next"><MdNavigateNext /></button>
								<span className="display_ib mt-xs">Next</span>
							</div>
						</div>
					}
					{
						view_mode &&
						<div className="text-center">
							<button
								className="customBtn btnBlue m-md"
								type='button'
								onClick={() => { this.props.history.goBack() }}
							>Go Back</button>
						</div>
					}
				</Col>
			</Row>
		</Grid>
		);

	}
}

const mapDispatchToProps = dispatch => {
	return ({
		storeBrandExportAttsCall: (data, id) => { return dispatch(brandActions.storeBrandExportAtts(data, id)) },
		storeBrandDataDefinitionCall: (data, id) => { return dispatch(brandActions.storeBrandDataDefinition(data, id)) }
	});
};

function mapStateToProps(state) {
	return {
	};
}


const ExportDataAttribute = withRouter(connect(mapStateToProps, mapDispatchToProps)(ExportDataAttributePage));
export default ExportDataAttribute;


// WEBPACK FOOTER //
// ./src/components/Admin/Brands/ExportDataAttribute.jsx